<template>
    <div class="car-add-form-container">
        <div class="page-title-container lighter-shadow" style="text-align: center;">
            <i class="fas fa-key icon"></i>
            <h1>Смяна на парола</h1>
        </div>
        <form class="page-content lighter-shadow" style="padding-top: 20px;">
            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'currentPassword'"
                       :name="'currentPassword'"
                       :label="'Настояща парола'"
                       :hidden="true"
                       :placeholder="'Въведете настоящата парола'"
                       :showError="shouldShowError('currentPassword')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('currentPassword')" :text="errors['currentPassword']"/>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'newPassword'"
                       :name="'newPassword'"
                       :label="'Нова парола'"
                       :hidden="true"
                       :placeholder="'Въведете новата парола'"
                       :showError="shouldShowError('newPassword')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('newPassword')" :text="errors['newPassword']"/>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'repeatNewPassword'"
                       :name="'repeatNewPassword'"
                       :label="'Повторете новата парола'"
                       :hidden="true"
                       :placeholder="'Повторете новата парола'"
                       :showError="shouldShowError('repeatNewPassword')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('repeatNewPassword')" :text="errors['repeatNewPassword']"/>

            <Button class="save-button"
                    @click.native="changePassword"
                    :color="'green'"
                    :text="'Запази'"
                    :icon="'fa fa-save'"></Button>
        </form>
    </div>
</template>

<script>
    import InputText from "@/shared/components/form/InputText";
    import Button from "@/shared/components/button/Button";
    import ErrorInput from "@/shared/components/form/ErrorInput";
    import redirectService from "@/services/redirect.service";
    import authorizationService from "@/services/authorization.service";

    export default {
        name: "ChangePassword",
        components: {ErrorInput, Button, InputText},
        created() {
            authorizationService.checkIsLoggedIn();
        },
        data() {
            return {
                currentPassword: null,
                newPassword: null,
                repeatNewPassword: null,
                errors: {}
            }
        },
        methods: {
            setAttribute(value) {
                this[value.name] = value.currentValue;
                this.errors[value.name] = null;
            },
            changePassword() {
                if (this.newPassword === this.repeatNewPassword) {
                    authorizationService.changePassword({
                        currentPassword: this.currentPassword,
                        newPassword: this.newPassword
                    })
                        .then(() => authorizationService.logout()
                            .then((response) => {
                                    if (response.status === 200) {
                                        redirectService.redirectToLogin();
                                    }
                                }
                            ))
                        .catch((errors) => this.errors = errors.response.data.errors);
                } else {
                    this.errors = {repeatNewPassword: this.repeatNewPassword ? 'Паролите трябва да съвпадат' : 'Не може да е празно'};
                }
            },
            shouldShowError(fieldName) {
                return !!(this.errors && this.errors[fieldName]);
            }
        }
    }
</script>

<style scoped>
    .car-add-form-container {
        width: 750px;
        height: fit-content;
        margin: 0 auto 60px auto;
    }

    .input {
        display: block;
        width: 500px;
        height: 95px;
        margin: 20px auto 0 auto;
    }

    .error {
        width: 500px;
        margin-top: -7px;
    }

    .save-button {
        width: 300px;
        height: 60px;
        font-size: 26px;
        margin: 45px;
    }

    .enum-dropdown {
        width: 500px;
        height: 95px;
        margin: 20px auto 0 auto;
    }
</style>
